function resolveEffectivePricing(card, selectedTerm) {
  var _card$availableTerms$;
  const selected = card.selectedTermPricing;
  if (selected) return {
    pricing: selected,
    term: selectedTerm
  };
  const fallback = (_card$availableTerms$ = card.availableTerms['ANNUAL']) !== null && _card$availableTerms$ !== void 0 ? _card$availableTerms$ : card.availableTerms['MONTHLY'];
  const fallbackTerm = typeof (fallback === null || fallback === void 0 ? void 0 : fallback.paymentTerm) === 'string' && fallback.paymentTerm === 'MONTHLY' ? 'MONTHLY' : 'ANNUAL';
  return {
    pricing: fallback,
    term: fallbackTerm
  };
}
function extractSeatMonthlyPrice(pricing) {
  var _pricing$productPrice;
  if (!pricing) return undefined;
  const productPrice = Object.values((_pricing$productPrice = pricing.productPrices) !== null && _pricing$productPrice !== void 0 ? _pricing$productPrice : {})[0];
  return productPrice ? parseFloat(productPrice.monthlyPrice) : undefined;
}
function extractMonthlyPrice(pricing, isPerSeat) {
  if (!pricing) return 0;
  const seatMonthlyPrice = extractSeatMonthlyPrice(pricing);
  if (isPerSeat && seatMonthlyPrice !== undefined) {
    return seatMonthlyPrice;
  }
  return parseFloat(pricing.monthlyPrice);
}
function extractTermDetails(card, selectedTerm) {
  const option = card.availableTerms[selectedTerm];
  const paymentTerm = typeof (option === null || option === void 0 ? void 0 : option.paymentTerm) === 'string' && option.paymentTerm === 'MONTHLY' ? 'MONTHLY' : 'ANNUAL';
  const commitmentTerm = typeof (option === null || option === void 0 ? void 0 : option.commitmentTerm) === 'string' && option.commitmentTerm === 'MONTHLY' ? 'MONTHLY' : 'ANNUAL';
  return {
    paymentTerm,
    commitmentTerm
  };
}
function calculateDiscountPercentage(card) {
  const annual = card.availableTerms['ANNUAL'];
  const monthly = card.availableTerms['MONTHLY'];
  if (!annual || !monthly) return 0;
  const annualPrice = parseFloat(annual.monthlyPrice);
  const monthlyPrice = parseFloat(monthly.monthlyPrice);
  if (monthlyPrice <= 0 || annualPrice >= monthlyPrice) return 0;
  return Math.round((monthlyPrice - annualPrice) / monthlyPrice * 100);
}
export function resolveCardPricing(card, selectedTerm) {
  const {
    pricing,
    term
  } = resolveEffectivePricing(card, selectedTerm);

  // Public pages are always a "free customer" context. Starter = crm-suite-starter-bundle
  // (per-seat on all hub pages). Mirror in-app logic: free customer + Starter → /mo/seat.
  const isPerSeat = card.quantifiable || card.productLevel === 'STARTER';
  return Object.assign({
    isFree: card.productLevel === 'FREE',
    effectiveTerm: term,
    isPerSeat,
    monthlyPrice: extractMonthlyPrice(pricing, isPerSeat),
    listPrice: pricing !== null && pricing !== void 0 && pricing.listPrice ? parseFloat(pricing.listPrice.monthlyPrice) : undefined,
    additionalSeatPrice: extractSeatMonthlyPrice(pricing)
  }, extractTermDetails(card, selectedTerm), {
    hasAnnual: !!card.availableTerms['ANNUAL'],
    hasMonthly: !!card.availableTerms['MONTHLY'],
    discountPercentage: calculateDiscountPercentage(card)
  });
}